import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Menu, X } from 'lucide-react';
import { useState } from 'react';
import { Button } from './ui/button';
import { UserDropdown, MobileMenu } from './nav/NavParts';

const NAV_LINKS = [
  { name: 'Features', href: '/#features' },
  { name: 'Pricing', href: '/pricing' },
  { name: 'About', href: '/about' },
  { name: 'Try Now', href: '/#try-now' },
  { name: 'Install', href: '/install' },
];

export function Navbar() {
  const { user, logout, isAdmin } = useAuth();
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const isActive = (path) => location.pathname === path;

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 backdrop-blur-xl bg-[#060C18]/80 border-b border-white/[0.06]" data-testid="navbar">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2.5" data-testid="navbar-logo">
            <img src="/sendpi-icon.png" alt="SendPI" className="h-11 w-auto" />
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {NAV_LINKS.map((link) => (
              <Link key={link.name} to={link.href}
                className={`text-sm font-medium transition-colors hover:text-white ${isActive(link.href) ? 'text-white' : 'text-white/50'}`}
                data-testid={`nav-${link.name.toLowerCase().replace(' ', '-')}`}>
                {link.name}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-4">
            {user ? (
              <UserDropdown user={user} isAdmin={isAdmin} logout={logout} />
            ) : (
              <>
                <Link to="/login" data-testid="nav-login"><Button variant="ghost" className="text-white/60 hover:text-white hover:bg-white/5 font-space">Login</Button></Link>
                <Link to="/signup" data-testid="nav-signup"><Button className="shimmer-btn text-white rounded-full px-6 font-space font-bold border-0">Start free</Button></Link>
              </>
            )}
          </div>

          <button className="md:hidden p-2 text-white/70 hover:text-white" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} data-testid="mobile-menu-toggle">
            {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {mobileMenuOpen && <MobileMenu navLinks={NAV_LINKS} user={user} isAdmin={isAdmin} logout={logout} onClose={() => setMobileMenuOpen(false)} />}
      </div>
    </nav>
  );
}
